import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import PropTypes from 'prop-types';
import { isEqual, pick } from 'lodash';
import { AbstractChart } from 'containers/charts/AbstractChart';
import ChartTile from 'components/molecules/charts/ChartTile';

import helpers from 'helpers';


class TwoAxisBarWithLineChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const series = [];
        const yAxis = [];
        const { orderedColors } = this.props.theme;

        let yLines = [this.props.yLine];
        let yLineTitles = [];

        if (Array.isArray(this.props.yLine)) {
            yLines = this.props.yLine;
            yLineTitles = this.props.yLine;

            // Check that the yLinesTitle array size matches yLine arrray.
            // If they dont match, we just use yLine
            if (this.props.yLineTitle && Array.isArray(this.props.yLineTitle)
                && this.props.yLineTitle.length === this.props.yLine.length) {
                yLineTitles = this.props.yLineTitle;
            }

            yLineTitles = yLineTitles.map(yLineTitle =>
                helpers.convertToDisplayValue(yLineTitle)
            );
        } else {
            yLineTitles = [helpers.convertToDisplayValue(this.props.yLineTitle || this.props.yLine)];
        }


        const { chartRef } = this;
        const yBarTitle = helpers.convertToDisplayValue(this.props.yBarTitle || this.props.yBar);

        let completeBarData;
        let completeLineData;
        if (!this.props.categories) {
            completeBarData = helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r[this.props.yBar] })), this.props.backfillBuckets
            );
            completeLineData = yLines.map(yLine => helpers.backfill(
                this.props.data.map(r => ({ x: r.date_in_ms, y: r[yLine] })),
                this.props.backfillBuckets
            ));
        } else {
            completeBarData = this.props.data.map(r => r[this.props.yBar]);
            completeLineData = yLines.map(yLine =>
                this.props.data.map(r => r[yLine])
            );
        }

        const barData = {
            ...(this.props.yBarOptions || {}),
            name: yBarTitle,
            data: completeBarData,
            type: 'column',
            yAxis: 1,
            color: orderedColors[0]
        };

        const lineDatas = yLines.map((yLine, index) => ({
            ...(this.props.yLineOptions || {}),
            name: yLineTitles[index],
            data: completeLineData[index],
            type: 'line',
            color: orderedColors[1 + index]
        }));

        series.push(barData, ...lineDatas);
        const xAxis = helpers.xAxisConfig({
            type: this.props.xAxisType,
            xAxisLabel: this.props.xAxisLabel,
            options: { categories: this.props.categories }
        });

        const yAxisBar = helpers.yAxisConfig({
            yAxisLabel: yBarTitle,
            options: {
                ...(this.props.yAxisBarOptions || {})
            }
        });

        const yAxisLines = yLines.map((yLine, index) => helpers.yAxisConfig({
            yAxisLabel: yLineTitles[index],
            options: {
                ...(this.props.yAxisLineOptions || {}),
                opposite: true
            }
        }));

        yAxis.push(yAxisLines[0], yAxisBar);

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                },
                marker: {
                    lineWidth: this.props.theme.charts.TwoAxisBarWithLineChart.marker.lineWidth,
                    lineColor: this.props.theme.charts.TwoAxisBarWithLineChart.marker.lineColor
                },
                column: {
                    borderWidth: 0
                }
            }
        };

        const chartTileProps = pick(this.props, ['title', 'subTitle', 'help', 'hideCSVExport']);

        return (
            <ChartTile {...chartTileProps} chartRef={chartRef}>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        navigation: {
                            buttonOptions: {
                                y: -20
                            }
                        },
                        credits: {
                            enabled: false
                        },
                        title: {
                            text: null
                        },
                        tooltip: {
                            shared: true,
                            ...(this.props.toolTipOptions || {})
                        },
                        legend: {
                            padding: 10,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        plotOptions,
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ChartTile>
        );
    }
}

TwoAxisBarWithLineChart.propTypes = {
    animateDuration: PropTypes.number.isRequired,
    backfillBuckets: PropTypes.array.isRequired,
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    exportName: PropTypes.string.isRequired,
    tactic: PropTypes.string,
    title: PropTypes.string.isRequired,
    toolTipOptions: PropTypes.object,
    xAxisLabel: PropTypes.string,
    xAxisType: PropTypes.string,
    yAxisBarOptions: PropTypes.object,
    yAxisLineOptions: PropTypes.object,
    yBar: PropTypes.string.isRequired,
    yBarOptions: PropTypes.object,
    yBarTitle: PropTypes.string,
    yLine: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    yLineTitle: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]),
    yLineOptions: PropTypes.object,
    help: PropTypes.node
};

export default withTheme(TwoAxisBarWithLineChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/TwoAxisBarWithLineChart.js